import { graphql, useStaticQuery } from 'gatsby'
import { FC, createContext, useContext, useState } from 'react'
import {
  MenuItem,
  TopCategoryItem,
} from 'src/components/common/Menu/global-navigation'
import {
  addMenuItemsIndex,
  getMenuSections,
  getSubHeaderMenu,
} from 'src/components/common/Menu/utils'

type Context = {
  updatedMenu: MenuItem[]
  menuSections: Array<MenuItem[]>
  subHeaderMenu: MenuItem[]
  topCategory: TopCategoryItem[]
  openCloseMenu: boolean
  setOpenCloseMenu: (a: boolean) => void
  hasClickedOnPrivateArea: boolean
  setHasClickedOnPrivateArea: (a: boolean) => void
}

const GlobalNavigationContext = createContext<Context>({} as Context)

export const GlobalNavigationProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [openCloseMenu, setOpenCloseMenu] = useState(false)
  const [hasClickedOnPrivateArea, setHasClickedOnPrivateArea] = useState(false)

  const globalNavigation = useStaticQuery(graphql`
    query GlobalNavigationQuery {
      allCmsGlobalNavigationMenu {
        nodes {
          navigationBar {
            menu {
              menuItems {
                logoImage
                title
                titleColor
                titleURL
                subtitle
                subtitleColor
                tag
                tagColor
                separator
                isMobile
                isDesktop
                subHeaderPosition
                nextLevel {
                  alphabeticalMenu
                  showAll
                  title
                  titleColor
                  titleURL
                  items {
                    logoImage
                    subHeaderImage
                    label
                    labelURL
                    openInNewTab
                    nextLevel {
                      alphabeticalMenu
                      showAll
                      title
                      titleColor
                      titleURL
                      items {
                        label
                        subHeaderImage
                        labelURL
                        openInNewTab
                        nextLevel {
                          alphabeticalMenu
                          showAll
                          title
                          titleColor
                          titleURL
                          items {
                            label
                            labelURL
                            openInNewTab
                          }
                        }
                      }
                    }
                  }
                }
              }
              topCategory {
                logoImage
                title
                titleURL
              }
            }
          }
        }
      }
    }
  `)

  const menuItems: MenuItem[] =
    globalNavigation.allCmsGlobalNavigationMenu.nodes[0].navigationBar.menu
      .menuItems

  const updatedMenu = addMenuItemsIndex(menuItems)

  const menuSections = getMenuSections(menuItems)

  const subHeaderMenu = getSubHeaderMenu(menuItems).sort((a, b) => {
    if (!a.subHeaderPosition || !b.subHeaderPosition) {
      return 0
    }
    return a.subHeaderPosition > b.subHeaderPosition ? 1 : -1
  })

  const topCategory: TopCategoryItem[] =
    globalNavigation.allCmsGlobalNavigationMenu.nodes[0].navigationBar.menu
      .topCategory

  const value = {
    updatedMenu,
    menuSections,
    subHeaderMenu,
    topCategory,
    openCloseMenu,
    setOpenCloseMenu,
    hasClickedOnPrivateArea,
    setHasClickedOnPrivateArea,
  }

  return (
    <GlobalNavigationContext.Provider value={value}>
      {children}
    </GlobalNavigationContext.Provider>
  )
}

export const useGlobalNavigation = () => {
  return useContext(GlobalNavigationContext)
}
